import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ReportCenterService } from '../../../services/report-center.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../Reports/report-lookup/report-lookup.component';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { SalesService } from '../../../services/sales.service';
import { gridPageRequest, SalesOrder } from '../../../model/common/common.model';

@Component({
  selector: 'app-order-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './order-lookup.component.html',
  styleUrl: './order-lookup.component.scss'
})
export class OrderLookupComponent {

  loader: boolean = false;
  searchKey: any;
  salesOrderHeader: any;
  poReceiptHeaderId: any;
  selectedOrder: any;
  selectedPOrder: any[] = [];
  salesOrderNumber: any;
  salesOrderId: any;
  listOrder: SalesOrder[] = [];

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  constructor(
    private config: DynamicDialogConfig,
    private reportService: ReportCenterService,
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    private porderservice: PurchaseorderService,
    private salesService: SalesService,


  ) { }


ngOnInit(): void {
  const salesOrderId = this.config.data?.salesOrderNumber.salesOrderId;
  this.poReceiptHeaderId = salesOrderId;
  this.getOrder(salesOrderId);
}


getOrder(salesOrderId: number): void {
  this.loader = true;

  this.salesService.getSalesOrderById(salesOrderId).subscribe({
    next: (order: any) => {
      this.selectedOrder = order;

      this.salesOrderId = order.salesOrderId;
      this.salesOrderNumber = order.salesOrderNumber;

      this.loader = false;
    },
    error: error => {
      console.error(error);
      this.loader = false;
    }
  });
}



  showProformaReport(): void {
    const formCode = 'Proforma Invoice';

    if (this.salesOrderNumber) {
      this.reportService.getReportName(formCode).subscribe({
        next: (report: any) => {
          const salesOrderNumber = this.salesOrderNumber;
          const sanitizedNumber = salesOrderNumber.replace(/[^a-zA-Z0-9]/g, "_");
          document.title = sanitizedNumber;

          this.ref = this.dialogService.open(ReportLookupComponent, {
           header: 'Proforma Invoice',
            width: '100%',
            data: {
              OrderNo: salesOrderNumber,
              ReportName: sanitizedNumber,
              ReportPath: report.path
            }
          });
          this.ref.onClose.subscribe(() => {
            document.title = 'Order List';
          });
        },
        error: (err: any) => {
          console.error(`Report not found for form code: ${formCode}`, err);
        }
      });
    } else {
      console.warn('No OrderNo provided for Order');
    }
  }


  showOrderReport(): void {
    const formCode = 'Order';

    if (this.salesOrderNumber) {
      this.reportService.getReportName(formCode).subscribe({
        next: (report: any) => {
          const salesOrderNumber = this.salesOrderNumber;
          const sanitizedNumber = salesOrderNumber.replace(/[^a-zA-Z0-9]/g, "_");
          document.title = sanitizedNumber;

          this.ref = this.dialogService.open(ReportLookupComponent, {
            header: report.formName,
            width: '100%',
            data: {
              OrderNo: salesOrderNumber,
              ReportName: sanitizedNumber,
              ReportPath: report.path
            }
          });
          this.ref.onClose.subscribe(() => {
            document.title = 'Order List';
          });
        },
        error: (err: any) => {
          console.error(`Report not found for form code: ${formCode}`, err);
        }
      });
    } else {
      console.warn('No OrderNo provided for Order');
    }
  }






}
